<template>
  <boxDropDown title="Gerenciamento de Integrações (API Tokens)">
    <template class="support-tools">

      <div class="form-group col-md-12">
        <label>Buscar tokens já configurados de uma empresa</label>
      </div>

      <div class="form-group col-md-12">
        <label for="integrationSearchCompanyId">ID da empresa</label>
        <input type="text" class="form-control" v-model="searchCompanyId" placeholder="ID da empresa" id="integrationSearchCompanyId">
      </div>

      <div class="send-data-tools form-group col-md-12">
        <button class="btn btn-primary" :disabled="loadingSearch" @click="searchIntegrations()">
          <span v-if="!loadingSearch">Buscar tokens</span>
          <span v-else class="loading-btn">
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </span>
        </button>
        <span class="send-data-tools__validate">{{ messageValidateSearch }}</span>
      </div>

      <div class="form-group col-md-12" v-if="searchResults.length > 0">
        <div class="table-responsive">
          <table class="table integration-table">
            <thead>
              <tr>
                <th>CompanyId</th>
                <th>Empresa</th>
                <th>Aplicação</th>
                <th>Token</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in searchResults" :key="row.tokenId">
                <td>{{ row.companyId }}</td>
                <td>{{ row.companyName }}</td>
                <td>{{ row.applicationName }}</td>
                <td>
                  <div class="token-cell">
                    <span class="token-cell__value">{{ row.token }}</span>
                    <ion-icon name="copy-outline" class="token-cell__copy" @click="copyText(row.token)"/>
                  </div>
                </td>
                <td>
                  <span :class="row.isActive ? 'badge-active' : 'badge-inactive'">{{ row.isActive ? 'Ativo' : 'Revogado' }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="form-group col-md-12" v-else-if="searched && !loadingSearch">
        <span>Nenhum token encontrado para essa empresa.</span>
      </div>

      <hr class="full-width">

      <div class="form-group col-md-12">
        <label>Criar nova integração e token de acesso</label>
      </div>

      <div class="form-group col-md-12">
        <label for="integrationCompanyId">ID da empresa</label>
        <input type="text" class="form-control" v-model="dataSend.companyId" placeholder="ID da empresa" id="integrationCompanyId">
      </div>

      <div class="form-group col-md-12">
        <label for="integrationAppName">Nome da aplicação</label>
        <input type="text" class="form-control" v-model="dataSend.thirdPartyApplicationName" placeholder="Nome da aplicação" id="integrationAppName">
      </div>

      <div class="form-group col-md-12">
        <label for="integrationAppUrl">URL da aplicação</label>
        <input type="text" class="form-control" v-model="dataSend.thirdPartyApplicationUrl" placeholder="https://" id="integrationAppUrl">
      </div>

      <div class="form-group col-md-12">
        <label for="integrationAppEmail">Email de contato</label>
        <input type="text" class="form-control" v-model="dataSend.thirdPartyApplicationEmail" placeholder="contato@parceiro.com" id="integrationAppEmail">
      </div>

      <div class="form-group col-md-12">
        <label for="integrationAppDescription">Descrição (opcional)</label>
        <textarea class="form-control" v-model="dataSend.thirdPartyApplicationDescription" placeholder="Descrição da integração" id="integrationAppDescription"></textarea>
      </div>

      <div class="form-group col-md-12">
        <label for="integrationBusinessUnit">Business Unit ID (opcional)</label>
        <input type="text" class="form-control" v-model="dataSend.businessUnitId" placeholder="Deixe em branco para acesso à empresa toda" id="integrationBusinessUnit">
      </div>

      <div class="form-group col-md-12">
        <label for="integrationUserId">User ID (opcional)</label>
        <input type="text" class="form-control" v-model="dataSend.userId" placeholder="ID do usuário associado" id="integrationUserId">
      </div>

      <div class="form-group col-md-12">
        <input type="checkbox" id="integrationIsProprietary" v-model="dataSend.isProprietarySoftware">
        <label for="integrationIsProprietary">É um software próprio da MarQ</label>
      </div>

      <div class="send-data-tools form-group col-md-12">
        <button class="btn btn-primary" :disabled="loadingCreate" @click="createIntegration()">
          <span v-if="!loadingCreate">Criar integração e token</span>
          <span v-else class="loading-btn">
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </span>
        </button>
        <span class="send-data-tools__validate">{{ messageValidateCreate }}</span>
      </div>

      <div class="form-group col-md-12 token-result" v-if="createdToken">
        <label>Token gerado — copie e envie para o responsável pela integração (não será exibido novamente aqui)</label>
        <div class="token-cell">
          <span class="token-cell__value">{{ createdToken }}</span>
          <ion-icon name="copy-outline" class="token-cell__copy" @click="copyText(createdToken)"/>
        </div>
      </div>

    </template>
  </boxDropDown>
</template>

<script>
  import boxDropDown from "../../../components/layouts/boxDropDown.vue";
  import {
    INTEGRATION_MANAGEMENT,
    SEARCH_SUPPORT
  } from "../../../../../urlConfig";
  import {
    REQUEST_SERVICE
  } from "../../../../../requestConfig";
  import {
    ALERT_SERVICE
  } from "../../../../../msgAlertService";

  export default {
    name: "integration-management",
    components: {
      boxDropDown,
    },
    data() {
      return {
        searchCompanyId: "",
        searched: false,
        loadingSearch: false,
        messageValidateSearch: "",
        searchResults: [],

        dataSend: {
          companyId: "",
          thirdPartyApplicationName: "",
          thirdPartyApplicationUrl: "",
          thirdPartyApplicationEmail: "",
          thirdPartyApplicationDescription: "",
          isProprietarySoftware: false,
          businessUnitId: "",
          userId: ""
        },
        loadingCreate: false,
        messageValidateCreate: "",
        createdToken: ""
      }
    },
    methods: {
      searchIntegrations() {
        if (this.searchCompanyId.trim().length !== 32) {
          this.messageValidateSearch = "Id da empresa é inválido";
          return;
        }

        this.messageValidateSearch = "";
        this.loadingSearch = true;
        this.searched = false;
        this.searchResults = [];

        REQUEST_SERVICE.get(`${INTEGRATION_MANAGEMENT}?companyId=${encodeURIComponent(this.searchCompanyId)}`)
          .then((response) => {
            let integrations = response.data || [];

            REQUEST_SERVICE.get(`${SEARCH_SUPPORT}${this.searchCompanyId}`)
              .then((companyResponse) => {
                this.buildSearchResults(integrations, companyResponse.data.name);
              })
              .catch(() => {
                this.buildSearchResults(integrations, "");
              });
          })
          .catch((reason) => {
            this.loadingSearch = false;
            this.searched = true;
            let message = reason.response ? this.extractErrorMessage(reason.response.data) : "";
            ALERT_SERVICE.swal("ERRO", message || "Entre em contato com a equipe de desenvolvimento", "error");
          });
      },
      buildSearchResults(integrations, companyName) {
        let rows = [];

        integrations.forEach((integration) => {
          (integration.tokens || []).forEach((token) => {
            rows.push({
              tokenId: token.id,
              companyId: integration.companyId,
              companyName: companyName,
              applicationName: integration.applicationName,
              token: token.key,
              isActive: token.isActive
            });
          });
        });

        this.searchResults = rows;
        this.searched = true;
        this.loadingSearch = false;
      },
      validateCreateFields() {
        if (this.dataSend.companyId.trim().length !== 32) {
          this.messageValidateCreate = "Id da empresa é inválido";
          return false;
        }

        if (!this.dataSend.thirdPartyApplicationName.trim()) {
          this.messageValidateCreate = "Informe o nome da aplicação";
          return false;
        }

        if (!this.dataSend.thirdPartyApplicationUrl.trim()) {
          this.messageValidateCreate = "Informe a URL da aplicação";
          return false;
        }

        if (!this.dataSend.thirdPartyApplicationEmail.trim()) {
          this.messageValidateCreate = "Informe o email de contato";
          return false;
        }

        this.messageValidateCreate = "";
        return true;
      },
      createIntegration() {
        if (!this.validateCreateFields()) {
          return;
        }

        this.loadingCreate = true;
        this.createdToken = "";

        let bodyRequestJSON = {
          companyId: this.dataSend.companyId,
          thirdPartyApplicationName: this.dataSend.thirdPartyApplicationName,
          thirdPartyApplicationUrl: this.dataSend.thirdPartyApplicationUrl,
          thirdPartyApplicationEmail: this.dataSend.thirdPartyApplicationEmail,
          thirdPartyApplicationDescription: this.dataSend.thirdPartyApplicationDescription,
          isProprietarySoftware: this.dataSend.isProprietarySoftware,
          businessUnitId: this.dataSend.businessUnitId,
          userId: this.dataSend.userId
        };

        REQUEST_SERVICE.post(INTEGRATION_MANAGEMENT, bodyRequestJSON)
          .then((response) => {
            this.loadingCreate = false;
            this.createdToken = this.extractToken(response.data);
            ALERT_SERVICE.swal("Sucesso", "Integração cadastrada com sucesso! Copie o token gerado abaixo.", "success");
            this.clearCreateFields();
          })
          .catch((reason) => {
            this.loadingCreate = false;
            let message = reason.response ? this.extractErrorMessage(reason.response.data) : "";
            ALERT_SERVICE.swal("ERRO", message || "Entre em contato com a equipe de desenvolvimento", "error");
          });
      },
      extractToken(responseText) {
        if (!responseText) return "";
        let match = String(responseText).match(/api_token:\s*(\S+)/);
        return match ? match[1] : String(responseText);
      },
      extractErrorMessage(data) {
        if (!data) return "";
        if (typeof data === "string") return data;
        return data.detail || data.title || data.message || "";
      },
      clearCreateFields() {
        this.dataSend.companyId = "";
        this.dataSend.thirdPartyApplicationName = "";
        this.dataSend.thirdPartyApplicationUrl = "";
        this.dataSend.thirdPartyApplicationEmail = "";
        this.dataSend.thirdPartyApplicationDescription = "";
        this.dataSend.isProprietarySoftware = false;
        this.dataSend.businessUnitId = "";
        this.dataSend.userId = "";
      },
      copyText(text) {
        if (!text) return;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text)
            .then(() => ALERT_SERVICE.swal("Copiado", "Token copiado.", "success"))
            .catch(() => this.fallbackCopy(text));
        } else {
          this.fallbackCopy(text);
        }
      },
      fallbackCopy(text) {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        try {
          document.execCommand("copy");
          ALERT_SERVICE.swal("Copiado", "Token copiado.", "success");
        } catch (e) {
          ALERT_SERVICE.swal("Aviso", "Não foi possível copiar.", "warning");
        }
        document.body.removeChild(ta);
      }
    }
  }
</script>

<style lang="scss" scoped>
  * {
    font-family: "Montserrat", sans-serif !important;
  }

  .send-data-tools {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 15px;

    &__validate {
      color: #ed6b75;
    }
  }

  .btn-primary {
    margin: 0 !important;
  }

  .full-width {
    width: 100% !important;
  }

  .integration-table {
    width: 100%;

    th, td {
      vertical-align: middle !important;
      word-break: break-all;
    }
  }

  .token-cell {
    display: flex;
    align-items: center;
    gap: 8px;

    &__value {
      font-family: monospace;
      word-break: break-all;
    }

    &__copy {
      cursor: pointer;
      color: #1b59f8;
      font-size: 18px;
      flex-shrink: 0;
    }
  }

  .token-result {
    background: #F0F0F0;
    border-radius: 8px !important;
    padding: 15px;
  }

  .badge-active {
    color: #14804A;
    background: #DFFFEA;
    border-radius: 8px !important;
    padding: 2px 10px;
    font-weight: bold;
  }

  .badge-inactive {
    color: #E74A4E;
    background: #FFE3E4;
    border-radius: 8px !important;
    padding: 2px 10px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/support/supportItems/integrationManagement.vue